import React, { useState, useEffect, useContext, useMemo} from 'react'
import { LangContext } from '../../../context/lang-context'
import { NavigationContext } from '../../../context/navigation-context'
import useForm from '../../../hooks/form-hook'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import NoResults from '../../../components/NoResults/NoResults'
import MachineForm from '../../../components/Modals/MachineForm'
import { Link } from 'react-router-dom'
import SearchFilter from '../../../components/Filter/SearchFilter'


const Machines = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const { setHeaderData } = useContext(NavigationContext)
  const { form, openForm, closeForm } = useForm()
  const [machines, setMachines] = useState([])
  const [machiesSerialNo, setMachinesSerialNo] = useState([])

  const getMachines = (f) => {
    fetchMssqlApi('console-machines', {method: "POST", hideNotification: true, data: {
      terminalId: f?.terminalId,
      machineId: f?.machineId,
      customerId: f?.customerId
    }}, machines => setMachines(machines))
  }

  const defaultFilter = {
    page: 1,
    sortBy: "none",
    consoleMachineId: null,
    consoleMachineName: "",
    customerName: "",
    customerId: null,
    terminalId: null,
    terminalSerialNo: ""
  };


  const badgeStyle = {
    fontWeight: "bold",
    padding: "6px 12px",
    fontSize: "13px",
    borderRadius: "4px",
    color: "white",
  };

  const getHbBadgeClass = (hb) => {
    if (!Number.isFinite(hb)) return "bg-secondary";
    if (hb <= 20) return "bg-danger";
    if (hb <= 80) return "bg-warning";
    return "bg-success";
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({});
  const makeSortComparator = (sortBy) => {
    if (!sortBy || sortBy === "none") return () => 0;
    const [field, order = "asc", type = "text"] = sortBy.split("|").map(s => s.trim());
    const norm = (v) => {
      if (v === null || v === undefined) return null;
      if (type === "price") return Number(String(v).replace(",", ".").replace(/\s/g, ""));
      if (type === "bool") return v ? 1 : 0;
      if (type === "date") {
        const t = new Date(v).getTime();
        return Number.isFinite(t) ? t : String(v).toUpperCase();
      }
      return String(v).toUpperCase();
    };
    return (a, b) => {
      const A = norm(a?.[field]);
      const B = norm(b?.[field]);
      if (A === B) return 0;
      if (A === null) return 1;
      if (B === null) return -1;
      const res = A < B ? -1 : 1;
      return order === "asc" ? res : -res;
    };
  };

  const sortedMachines = useMemo(() => {
      const cmp = makeSortComparator(filter.sortBy);
      return [...machines].sort(cmp);
    }, [machines, filter.sortBy]);
  

  const machineSortFields = [
    { label: "Klient", field: "CustomerAbbr", type: "text" },
    { label: "Nr seryjny", field: "SerialNo", type: "text" },
    { label: "Terminal", field: "TerminalSerialNo", type: "text" },
  ];

  useEffect(() => {
    machines.map(machine => {
      machine.MachineSerialNo.includes("_")
          ? setMachinesSerialNo(prev => [...prev, machine.MachineSerialNo.split('_')[1]])
          : setMachinesSerialNo(prev => [...prev, machine.MachineSerialNo])
    })
  } , [machines])

  useEffect(() => {
    setHeaderData({ text: TRL_Pack.machines.header })
  }, [])
 
  return (
      machines && (
          <div>
            <SearchFilter
              filterName="consolemachines"
              defaultFilter={defaultFilter}
              onFilterChange={(f) => setFilter(f)}
              onSettingsChange={(s) => setSettingsFilter(s)}
              search={getMachines}
              totalCount={machines.slice((filter.page - 1) * settingsFilter?.rowsPerPage, filter.page * settingsFilter?.rowsPerPage).length}
              isSorted
              sortFields={machineSortFields}
              forNow
            />
                <>
                  <div>
                    <button
                        className="d-block btn btn-link text-decoration-none ml-auto my-2 mr-1"
                        onClick={openForm()}
                    >
                      <i className="fas fa-plus mr-2" /> Dodaj automat
                    </button>
                  </div>

                  <div className="overflow-auto">


                    <table className="table table-striped border">
                      <thead>
                      <tr>
                        <th>Klient</th>
                        <th style={{textAlign: "center"}}>Baza danych</th>
                        <th>Automat</th>
                        <th>Terminal</th>
                        <th style={{textAlign: 'center'}}>Rozliczanie sprzedaży przez Transakcje</th>
                        <th style={{textAlign: 'center'}}>Rozliczanie sprzedaży przez Transakcje R24 VMC</th>
                        <th>Stabilność połączenia</th>
                      </tr>
                      </thead>
                      <tbody>
                      {sortedMachines.map((machine, idx) => (
                              <tr key={idx}>
                                <td>{machine.CustomerName}</td>
                                <td>
                                  <div style={{textAlign: "center"}}>
                                    {machine.Abbreviation.toLowerCase() || <bold>brak</bold>}
                                  </div>
                                </td>
                                <td>
                                  <Link
                                      to={`/machine/${machine.MachineId}`}
                                      className="btn btn-link font-size-inherit text-reset text-decoration-none p-1"
                                  >
                                    { machine.MachineSerialNo !== machine.MachineName ? `${machine.MachineName} (${machine.MachineSerialNo})` : machine.MachineSerialNo}
                                  </Link>
                                </td>

                                <td>{(machine.TerminalTypeId == 1) && `Vendotek  ${machine.TerminalSerialNo}`
                                    ||(machine.TerminalTypeId == 2) && `PAX  ${machine.TerminalSerialNo}`
                                    ||(machine.TerminalTypeId == 3) && `NAYAX  ${machine.TerminalSerialNo}`
                                    ||(machine.TerminalTypeId == 4) && `Newland  ${machine.TerminalSerialNo}`
                                    ||(machine.TerminalTypeId == 5) && `NEXGO  ${machine.TerminalSerialNo}`
                                    || ""} </td>
                                <td style={{textAlign: 'center'}}><i className={machine.UseTrxForSales ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                                <td style={{textAlign: 'center'}}><i className={machine.UseVMCTrx ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                                <td>
                                  <div className="badge align-middle d-flex justify-content-center">
                                    <div
                                      className={getHbBadgeClass(Number(machine.HBSuccessRatio))}
                                      style={badgeStyle}
                                    >
                                      {Number(machine.HBSuccessRatio)}%
                                    </div>
                                  </div>
                                </td>
                              </tr>

                          ))}
                      </tbody>
                    </table>
                    {machines.length === 0 && (<NoResults buttonText={TRL_Pack.machine.addMachine} onClick={openForm()} />)}
                  </div>
                </>
            {form && <MachineForm serialNoArr={machiesSerialNo} postSubmit={getMachines} handleClose={closeForm}/>}
          </div>
      )

  )
}

export default Machines;